<template>
  <div class="page" ref="page">
    <mobileHeader title="拓客奖励" rightType="none" />
    <div class="my-extension">
      <div
        class="item no-select"
        v-show="myExtension[0].text"
        v-for="(it, i) in myExtension"
        :key="i"
        @click="touchItem(i)"
      >
        <div class="item-title" :style="i == actItem && 'color: white'">{{ it.title }}</div>
        <div class="item-text" :style="i == actItem && 'color: white'">{{ it.text }}</div>
        <div class="item-touch"></div>
      </div>
      <div :class="'mask' + i" v-for="(it,i) in 2" :key="'A'+i"></div>
      <div class="select" :class="'select' + actItem"></div>
    </div>
    <div class="tips no-select">
      <div @click="popupShow = true">
        奖励使用说明<span class="iconfont icon-arrow-right"></span>
      </div>
    </div>
    <van-swipe
      class="my-swipe"
      ref="my-swipe"
      :style="'height: calc(100vh - 63.4vw)'"
      :show-indicators="false"
      :loop="false"
      @change="itemChange"
    >
      <template v-for="(it, index) in myExtension">
         <van-swipe-item :key="index" @scroll="scrollGet">
          <div
            v-for="(it, i) in it.list"
            :key="i"
            class="promotion-award-item"
            :style="it.usea == '未使用' ? bgList[index] : bgList[3]"
            :class="it.usea == '未使用' && 'no-invalid'"
          >
            <div class="item-content">
              <div v-if="it.promote_type == 4">
                您邀请的客户<br/>（账号：{{it.phone}}，提成{{it.commission_ratio}}%）成交了{{it.total_amount}}元，您本单的提成金额为{{it.commission_amount}}元。
              </div>
              <div v-else>
                成功邀请了一位新客户 <br/>（账号：{{ it.phone }}）
              </div>
              <div v-if="it.promote_type == 3">
                （您可凭此信息去配送站点领取，也可等待下次订气时由配送工为您送货上门）。
              </div>
            </div>
            <div class="item-time">
              <div>{{ it.update_time }}</div>
              <div>
                <img
                  v-if="it.promote_type == 3"
                  :src="it.usea == '未使用' ? buttonList[index] : buttonList[3]"
                  alt=""
                />
              </div>
            </div>
            <div class="item-right no-select">
              <template v-if="it.promote_type == 1">
                <div><span>￥</span>{{it.amount}}</div>
                <div>现金奖励</div>
              </template>
              <template v-if="it.promote_type == 4">
                <div>{{it.commission_ratio}}<span>%</span></div>
                <div>提成</div>
              </template>
              <template v-if="it.promote_type == 3">
                <div style="font-size: 6vw;line-height: 10vw;padding: 3vw">{{it.gift_name}}</div>
              </template>
            </div>
          </div>
          <van-divider v-if="loading">加载中...</van-divider>
          <van-divider v-if="it.nomore">没有更多了</van-divider>
        </van-swipe-item>
      </template>
    </van-swipe>
    <img class="see-achievement" @click="$router.push('/inviteFriends/myAchievement')" src="@/assets/images/see-achievement-icon.png" alt="">
    <!-- <van-empty v-show="!loading" image="error" description="暂无数据" /> -->
    <popupBox :show="popupShow" @submit="popupShow = false">
      <div
        :style="`opacity: ${popupShow ? 1 : 0};transform: scale(${
          popupShow ? 1 : 0.8
        });`"
        class="promotion-award-tips"
      >
        <img src="@/assets/images/dankuang.png" alt="" />
        <img
          src="@/assets/images/qd-anniu.png"
          alt=""
          @click="popupShow = false"
        />
      </div>
    </popupBox>
  </div>
</template>

<script>
import mobileHeader from "@/components/mobileHeader";
import popupBox from "@/components/popupBox";
import { getRewardCount, getInviteList } from "@/api/inviteFriends";
import { Toast } from "vant";
export default {
  components: {
    mobileHeader,
    popupBox,
  },
  data() {
    return {
      myExtension: [
        {
          title: "现金奖励",
          text: "",
          page: 1,
          list: [],
          nomore: false,
        },
        // {
        //   title: "提成",
        //   text: "",
        //   page: 1,
        //   list: [],
        //   nomore: false
        // },
        {
          title: "礼品",
          text: "",
          page: 1,
          list: [],
          nomore: false
        },
      ],
      list: [],
      popupShow: false,
      loading: false,
      nomore: false,
      actItem: 0,
      bgList: [
          `background-image: url(${require('../../assets/images/juan-wl.png')});`,
          `background-image: url(${require('../../assets/images/juan-wl-1.png')});`,
          `background-image: url(${require('../../assets/images/juan-wl-2.png')});`,
          `background-image: url(${require('../../assets/images/juan-yi-1.png')});`,
      ],
      buttonList: [
          require('../../assets/images/weilingqu-0.png'),
          require('../../assets/images/weilingqu-1.png'),
          require('../../assets/images/weilingqu-2.png'),
      ]
    };
  },
  created() {
    this.getRewardCount()
    this.getInviteList('0');
    // this.getInviteList('1');
    this.getInviteList('1');
  },
  computed: {
    isTest(){
        return this.$store.state.isTest
    }
  },
  methods: {
    async getRewardCount(){
      const {code, data, msg} = await getRewardCount()
      if (code != 200) Toast({ message: msg, duration: 500 });
      this.myExtension[0].text = `￥${data.cash_reward || 0}`;
      // this.myExtension[1].text = `${data.commission || 0}%`;
      this.myExtension[1].text = data.amount ? `价值${data.amount}元礼品` : '暂无';
    },
    async getInviteList(t) {
      console.log(this.myExtension[t || this.actItem].nomore,"this.nomore")
      if (!t && this.loading) return false;
      if (!t && this.myExtension[t || this.actItem].nomore) return false
      this.loading = true;
      // const obj = {'0': 1, '1': 4, '2': 3}
      const obj = {'0': 1, '1': 3, '2': 3}
      console.log(obj[this.actItem])
      const { data, code, msg } = await getInviteList({type: obj[t || this.actItem], page: this.myExtension[t || this.actItem].page, size: 10});
      this.loading = false;
      if (code != 200) Toast({ message: msg, duration: 500 });
      t == 1 && data.map(it => {
        (it.commission_amount = (it.total_amount * (it.commission_ratio / 100)).toFixed(2))
      })
      data && this.myExtension[t || this.actItem].list.push(...data)
      !data.length ? (this.myExtension[t || this.actItem].nomore = true) : this.myExtension[t || this.actItem].page++
    },
    touchItem(i) {
      this.actItem = i;
      this.$refs["my-swipe"].swipeTo(i);
      this.nomore = false
    },
    scrollGet(e) {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.srcElement.scrollTop;
      //变量windowHeight是可视区的高度
      let windowHeight = e.srcElement.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight = e.srcElement.scrollHeight;
      scrollTop + windowHeight >= scrollHeight - 100 &&
        (console.log("到底了"), this.getInviteList());
    },
    itemChange(i) {
      this.actItem = i;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .header-title{
  font-size: 5vw;
}
.page {
  background: #f7f7f7;
  min-height: 100vh;
  height: fit-content;
  .loading {
    text-align: center;
  }
  .my-extension {
    width: 100%;
    height: 20.8vw;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    // position: sticky;
    // top: 10vw;
    z-index: 99;
    position: relative;
    & > .item {
      flex: 1;
      text-align: center;
      position: relative;
      padding: 10px 0;
      .item-title {
        font-size: 4.4vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 7.1vw;
        transition: color 1s;
      }
      .item-text {
        font-size: 3.2vw;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #2E8DFF;
        line-height: 5vw;
        transition: color 1s;
      }
    }
    & > .item + .item::before {
      content: "";
      min-width: 1px;
      width: 1px;
      height: calc(100% - 20px);
      position: absolute;
      background: #b5b5b5;
      left: -1px;
      top: 10px;
    }
    & > .select {
      width: 48%;
      margin-left: 0.76%;
      position: absolute;
      height: 1px;
      background: rgba(85, 125, 170, 0.158);
      // top: 10%;
      // height: 80%;
      top: 2.08vw;
      height: 16.64vw;
      z-index: -1;
      background-image: url('../../assets/images/2-kuang-bg-yd.png');
      background-size: 100% 100%;
      &::before {
        display: none;
      }
      transition: all 0.3s;
      animation-timing-function: cubic-bezier(0.8, 1.17, 0.05, 0.32);
    }
    & > .select0 {
      left: 0;
    }
    & > .select1 {
      left: 50%;
    }
    .mask0, .mask1{
        width: 48%;
        margin-left: 0.76%;
        position: absolute;
        height: 1px;
        background: rgba(85, 125, 170, 0.158);
        top: 10%;
        height: 80%;
        z-index: -1;
        background: white;
        border-radius: 1.4vw;
    }
    & > .mask0 {
      left: 0;
    }
    & > .mask1 {
      left: 50%;
    }
    // & > .mask2 {
    //   left: 66.66%;
    // }
    
  }
  .tips {
    font-size: 4.2vw;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #2e8dff;
    line-height: 5vw;
    text-align: end;
    padding: 2.6vw;
    padding-bottom: 0;
    div {
      display: inline-block;
    }
  }
  .tips:active {
    opacity: 0.8;
  }
  .my-swipe {
    // height: calc(100vh - 18.1vw - 5vw - 2.6vw - 10vw - 2.7vw - 25vw);
    height: calc(100vh - 44.9vw);
    // height: calc(100vh - 63.4vw);

    ::v-deep .van-swipe-item {
      height: 100%;
      overflow: auto;
    }
  }
  .see-achievement{
    width: 85.6vw;
    height: 12.5vw;
    margin-left: 7.3vw;
    margin-top: 6vw;
  }
  .see-achievement:active{
    opacity: 0.9;
  }
  .promotion-award-item {
    background-size: 100% 100%;
    width: 100%;
    height: 44vw;
    position: relative;
    .item-content {
      height: 30vw;
      margin: 0 7vw;
      padding-top: 2vw;
      position: relative;
      line-height: 5vw;
      font-family: Source Han Sans CN;
      div:nth-child(1) {
        padding-top: 4vw;
        font-size: 3.9vw;
        font-weight: 500;
        color: #9c9c9c;
        width: 60%;
      }
      div:nth-child(2) {
        position: absolute;
        bottom: 2vw;
        font-size: 2.3vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #9c9c9c;
        line-height: 3vw;
        width: 64%;
      }
    }
    .item-time {
      display: flex;
      height: 8vw;
      width: 54%;
      padding: 0 7vw;
      align-items: center;
      justify-content: space-between;
      div:nth-child(1) {
        font-size: 3.3vw;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #b8b6b6;
        line-height: 6vw;
        position: relative;
        &::after{
          content: "";
          position: absolute;
          top: -2px;
          left: 0;
          width: 100%;
          height: 1px;
          background: #ccc;
          transform: scaleY(0.5);
          border-radius: 50px;
        }
      }
      div:nth-child(2) {
        height: 6vw;
        img {
          height: 6vw;
        }
        .act-img:active {
          opacity: 0.5;
        }
      }
    }
    .item-right{
      width: 32vw;
      position: absolute;
      top: 0;
      right: 1.5vw;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      & > div:nth-child(1){
        font-size: 8vw;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 14vw;
        span{
          font-size: 4.8vw;
        }
      }
      & > div:nth-child(2){
        font-size: 4vw;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 5vw;
      }
    }
  }
  .no-invalid {
    .item-content > div:nth-child(1){
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #666666;
      span {
        color: #fe542b;
      }
    }
    .item-content > div:nth-child(2) {
        color: #A540F7;
      
    }
    .item-time > div:nth-child(1) {
      color: #666666;
    }
  }
  .promotion-award-tips {
    width: 100%;
    height: 100%;
    // position: absolute;
    width: 100%;
    text-align: center;
    height: fit-content;
    transition: all 0.3s;
    animation-timing-function: ease-in-out;
    img:nth-child(1) {
      width: 77.6vw;
    }
    img:nth-child(2) {
      width: 69.4vw;
      margin-top: 11vw;
    }
    img:nth-child(2):active {
      opacity: 0.8;
    }
  }
}
</style>